import React from 'react'

import { Tooltip } from '@mui/material'
import { SimpleCollapse, Input, TextArea, Row, Button } from 'components'
import { InfoIcon } from 'components/Icons'
import { useModal } from 'hooks'
import { SPACING } from 'utils'

interface IEmailProps {
  control: any
  errors: any
  handleCleanEmail: any
}

const Email: React.FC<IEmailProps> = ({
  control,
  handleCleanEmail,
  errors
}) => {
  const { showModal } = useModal()
  return (
    <SimpleCollapse title="E-MAIL">
      <Row>
        <Input
          control={control}
          errors={errors}
          formValue="txAssuntoEmail"
          label="Assunto E-mail"
          placeholder="Digite o Assunto"
          width="482px"
          maxLength={300}
        />
        <Tooltip
          placement="right"
          title="Caso o assunto seja deixado em branco, será utilizado um assunto padrão."
        >
          <InfoIcon
            marginTop={SPACING.spacing20}
            marginLeft={SPACING.spacing20}
            cursor="pointer"
            onClick={() =>
              showModal({
                hideButtonCancel: true,
                message:
                  'Caso o assunto seja deixado em branco, será utilizado um assunto padrão.',
                titleModal: 'Atenção',
                txtButtonConfirm: 'Fechar',
                type: 'alert'
              })
            }
          />
        </Tooltip>
      </Row>

      <TextArea
        maxLength={2000}
        control={control}
        errors={errors}
        formValue="txCorpoEmail"
        label="Texto E-mail"
        maxWidth="97%"
        width="97%"
        limitCount={2000}
        minRows={8}
        marginTop={SPACING.spacing15}
        placeholder={`Prezado Fornecedor,\nPor favor, entre em contato com a CSN.`}
      />

      <Row alignItems="center" justifyContent="end">
        <Button text="Limpar" onClick={handleCleanEmail} variantButton="text" />
      </Row>
    </SimpleCollapse>
  )
}

export default Email
